/* eslint-disable import/extensions */
import { Auth0ConnectAppLoginPageHelper } from './implementations/auth0-connect-app-login-helper.mst.mjs';
import Auth0Constants from '../../../utils/auth0-constants.mjs';

const registeredExternalApps = [{
  name: 'ShipStation Connect',
  id: Auth0Constants.EXTERNAL_APP_ID_SHIPSTATION_CONNECT,
  AppClass: Auth0ConnectAppLoginPageHelper,
}];

export default {
  registeredExternalApps,
  appFromConfig: (appId, options) => {
    const appData = registeredExternalApps.filter(a => a.id === appId)?.pop();
    if (!appData) {
      throw new Error(`External app registry could not resolve app with ID "${appId}"`);
    }
    return new appData.AppClass({
      ...options,
      name: appData.name,
    });
  },
};
